import { render, staticRenderFns } from "./MovimientosAMLS.vue?vue&type=template&id=2706c04c"
import script from "./MovimientosAMLS.vue?vue&type=script&lang=js"
export * from "./MovimientosAMLS.vue?vue&type=script&lang=js"
import style0 from "./MovimientosAMLS.vue?vue&type=style&index=0&id=2706c04c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports